/* drinkware – mega-menu header behaviour (industrial redesign 2026-10-26, preview theme only).
   Disclosure pattern: buttons with aria-expanded/aria-controls. Hover (fine pointers) or keyboard focus opens,
   click toggles, Esc closes and returns focus, focus/pointer leaving closes. Mobile drawer + accordion. */
(function () {
  function init(root) {
    if (root.dataset.dwMhReady) return;
    root.dataset.dwMhReady = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-dw-mh-item]'));
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var openItem = null, closeTimer = null;

    function parts(item) {
      var btn = item.querySelector('[data-dw-mh-trigger]');
      return { btn: btn, panel: btn && document.getElementById(btn.getAttribute('aria-controls')) };
    }
    function open(item) {
      clearTimeout(closeTimer);
      if (openItem && openItem !== item) close(openItem);
      var p = parts(item); if (!p.panel) return;
      if (p.btn.getAttribute('aria-expanded') === 'true') return;
      p.btn.setAttribute('aria-expanded', 'true'); p.panel.hidden = false;
      item._openedAt = Date.now(); openItem = item;
    }
    function close(item, focusBtn) {
      var p = parts(item); if (!p.panel) return;
      p.btn.setAttribute('aria-expanded', 'false'); p.panel.hidden = true;
      if (openItem === item) openItem = null;
      if (focusBtn) { item._noReopen = true; p.btn.focus({ preventScroll: true }); item._noReopen = false; }
    }
    items.forEach(function (item) {
      var p = parts(item); if (!p.btn) return;
      p.btn.addEventListener('click', function () {
        var expanded = p.btn.getAttribute('aria-expanded') === 'true';
        if (expanded && Date.now() - (item._openedAt || 0) > 350) close(item); else open(item);
      });
      p.btn.addEventListener('focus', function () { if (!item._noReopen && p.btn.matches(':focus-visible')) open(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeTimer = setTimeout(function () { close(item); }, 10);
      });
      /* Hover only for real mouse pointers (touch taps use click). */
      item.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' && !canHover) return;
        if (window.innerWidth < 1024) return;
        clearTimeout(closeTimer); open(item);
      });
      item.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse' && !canHover) return;
        closeTimer = setTimeout(function () { close(item); }, 180);
      });
    });

    /* Search row */
    var sBtn = root.querySelector('[data-dw-mh-search-toggle]'), sRow = root.querySelector('[data-dw-mh-search]');
    function setSearch(on) {
      if (!sBtn || !sRow) return;
      sBtn.setAttribute('aria-expanded', on ? 'true' : 'false'); sRow.hidden = !on;
      if (on) { var i = sRow.querySelector('input[type="search"]'); if (i) i.focus(); }
      updateBottom();
    }
    if (sBtn) sBtn.addEventListener('click', function () { setSearch(sRow.hidden); });

    /* Mobile drawer */
    var burger = root.querySelector('[data-dw-mh-burger]'), drawer = root.querySelector('[data-dw-mh-drawer]');
    function setDrawer(on, focusBack) {
      if (!burger || !drawer) return;
      updateBottom();
      burger.setAttribute('aria-expanded', on ? 'true' : 'false'); drawer.hidden = !on;
      document.documentElement.classList.toggle('dw-mh-locked', on);
      if (!on && focusBack) burger.focus();
    }
    if (burger) burger.addEventListener('click', function () { setDrawer(drawer.hidden); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-dw-mh-acc]'), function (b) {
      b.addEventListener('click', function () {
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        var on = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', on ? 'true' : 'false'); if (panel) panel.hidden = !on;
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (openItem) { close(openItem, true); return; }
      if (drawer && !drawer.hidden) { setDrawer(false, true); return; }
      if (sRow && !sRow.hidden) { setSearch(false); sBtn.focus(); }
    });
    document.addEventListener('click', function (e) { if (openItem && !openItem.contains(e.target)) close(openItem); });

    function updateBottom() {
      var r = root.getBoundingClientRect();
      root.style.setProperty('--dw-mh-bottom', Math.max(0, Math.round(r.bottom)) + 'px');
      document.body.style.setProperty('--header-height', Math.round(root.offsetHeight) + 'px');
    }
    window.addEventListener('resize', function () {
      updateBottom();
      if (window.innerWidth >= 1024 && drawer && !drawer.hidden) setDrawer(false);
    });
    /* Horizon scrolls .page-wrapper, not window: listen in capture phase. */
    document.addEventListener('scroll', function () { if (drawer && !drawer.hidden) updateBottom(); }, { passive: true, capture: true });
    updateBottom();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-dw-mh]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
